export enum WC_PREFIXES {
  CUSTOM_EVENT_INIT = 'cf-init',
  CUSTOM_EVENT = 'cf-out',
  INPUT = 'cf-in',
}
